import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/member/ALangsetField/index",{
        params: {
            page:params
        }
    } )
}

function SUBMIT_ADDLIST(params) {
    return  axios.post("/member/ALangsetField/addPost",{...params} )
}
function GET_DATA(params) {
    return axios.get("/member/ALangsetField/edit",{   params: {
            id: params
        } } )
}
function SUBMIT_ZDDATA(params) {
    return axios.post("/member/ALangsetField/editPost",{...params} )
}
// function SUBMIT_ADD(params) {
//     return  axios.post("/member/AMemberSetting/editPost",{...params} )
// }
function GET_EDITLIST(params) {
    return axios.get("/member/ALangsetField/editLangContent",{   params: {
            ...params
        } }  )
}
function SUBMIT_EDITLIST(params) {
    return axios.post("/member/ALangsetField/editBatchContentPost",{langContent:params }  )
}

function DELE(params) {
        return  axios.get("/member/ALangsetField/delete",{
            params: {
                ids:params
            }
        } )
    }
function FIELD(params) {
    return  axios.post("/member/ALangsetField/translationLangField",{...params  } )
}

export default {
    GET_LIST,
    SUBMIT_ADDLIST,
    GET_DATA,
    SUBMIT_ZDDATA,
    DELE,
    GET_EDITLIST,
    SUBMIT_EDITLIST,
    FIELD
    // SUBMIT_ADD,

};
